(function () {
    window.onerror = function (errorMessage, scriptURI, lineNumber, columnNumber, errorObj) {
        record({
            reportType: 'runtimeError',
            dataCustomized: {
                errorMessage, scriptURI, lineNumber, columnNumber, errorObj
            }
        })
    }

    function record(errorObj) {
        try {
            sessionStorage.setItem(String(Date.now()), JSON.stringify(errorObj))
        } catch (e) {
            console.warn('>>>>>>>>>>>>>>>>>>>> 保存 error log 时出现错误 <<<<<<<<<<<<<<<<<<<<<<<<<<')
        }
    }
})()